<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">회원정보 신규등록</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>아이디</span></th>
                  <td> {{userInfo.clinic_doctor_id}}</td>
                </tr>
                <tr>
                  <th><span>한의사명</span></th>
                  <td> {{userInfo.doctor_nm}}</td>
                </tr>
                <tr>
                  <th><span>생년월일</span></th>
                  <td> {{userInfo.doctor_birth_year}}-{{toTwoDigits(userInfo.doctor_birth_month)}}-{{toTwoDigits(userInfo.doctor_birth_day)}}</td>
                </tr>
                <tr>
                  <th><span>핸드폰번호</span></th>
                  <td>{{ formatPhoneNumber(userInfo.doctor_phone_num)}}</td>
                </tr>
                <tr>
                  <th><span>한의사 우편번호</span></th>
                  <td>{{userInfo.doctor_post_no}}</td>
                </tr>
                <tr>
                  <th><span>한의사 주소</span></th>
                  <td>{{userInfo.doctor_addr_addr}}</td>
                </tr>
                <tr>
                  <th><span >한의사 상세주소</span></th>
                  <td>{{userInfo.clinic_addr_dtl}}</td>
                </tr> 
                <tr>
                  <th><span>이메일</span></th>
                  <td>{{userInfo.doctor_email}}</td>
                </tr>
                <tr>
                  <th><span>한의사 면허정보</span></th>
                  <td>                   
                     <div class="form_inline">
                      {{userInfo.doctor_license_num}}
                    </div></td>
                </tr>  
                <tr>
                  <th><span>한의원명</span></th>
                  <td>{{userInfo.clinic_nm}}</td>
                </tr>
                <tr>
                  <th><span>연락처</span></th>
                  <td>
                     {{ formatPhoneNumber(userInfo.doctor_tel_num)}}
                  </td>
                </tr>
                <tr>
                  <th><span>사업자등록번호</span></th>
                  <td>{{formatBizNumber(userInfo.clinic_business_num)}}</td>
                </tr>                
                <tr>
                  <th><span>한의원 우편번호</span></th>
                  <td>{{userInfo.clinic_post_no}}</td>
                </tr>
                <tr>
                  <th><span>한의원 주소</span></th>
                  <td>{{userInfo.clinic_addr}}</td>
                </tr>
                <tr>
                  <th><span >한의원 상세주소</span></th>
                  <td>{{userInfo.clinic_addr_dtl}}</td>
                </tr>              
                <tr>
                  <th><span>문자발송 여부</span></th>
                  <td>
                      {{userInfo.doctor_phone_recv_yn}}
                  </td>
                </tr>                
                <tr>
                  <th><span>이메일발송 여부</span></th>
                  <td>
                    {{userInfo.doctor_email_recv_yn}}
                  </td>
                </tr>
                <tr>
                  <th><span>승인여부</span></th>
                  <td>
                    <div class="form_select">
                      <b-form-select v-model="userInfo.approval_yn" class="w200">
                        <b-form-select-option value="Y">승인</b-form-select-option>
                        <b-form-select-option value="N">승인취소</b-form-select-option>
                      </b-form-select>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_list_page">목록</button>
              <div class="btn_box">
                <button class="btn btn_md btn_blue" @click="fn_save">저장</button>
                <button class="btn btn_md btn_gray" @click="fn_delete">삭제</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'UserMngtDtl',
    mixins: [commonUtil],
    components: {
    },
    data() {
      return {
        clinicDoctorId: '',
        userInfo : {}
      }
    },
    created(){
        this.clinicDoctorId = this.$store.getters['userMngt/getClinicDoctorId']
        console.log("@@@@ clinicDoctorId : "+this.clinicDoctorId);
    },
    mounted(){
      this.fn_search();
    },
    methods : {
      fn_search(){

        let param = new Object();
        param.clinicDoctorId = this.clinicDoctorId;

        axios
            .post("/api/admin/userMngt/getUserInfo", param)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                this.userInfo = res.data.userInfo;

                console.log("@@@@ userInfo : %o",this.userInfo);                

            })
            .catch((err) => console.log(err));
      },
      fn_move_list_page(){
          this.$store.dispatch('userMngt/setClinicDoctorId', '');
          this.$router.push("/admin/userMngt/userMngtList");
      },
      fn_save(){

        let param = new Object();
        param.clinic_doctor_id = this.clinicDoctorId;
        param.approval_yn = this.userInfo.approval_yn;

        axios
            .post("/api/admin/userMngt/updateApprovalYn", param)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                alert("저장되었습니다");
                this.fn_search();
            })
            .catch((err) => console.log(err));
      },
      fn_delete(){

        let param = new Object();
        param.clinicDoctorId = this.clinicDoctorId;

        axios
            .post("/api/admin/userMngt/deleteUserInfo", param)
            .then((res) => {
                alert("삭제되었습니다");
                this.fn_move_list_page();
            })
            .catch((err) => console.log(err));
      },
    }
  }
</script>